import { render, staticRenderFns } from "./GlassBatchManualForm.vue?vue&type=template&id=415825bc&scoped=true&"
import script from "./GlassBatchManualForm.vue?vue&type=script&lang=js&"
export * from "./GlassBatchManualForm.vue?vue&type=script&lang=js&"
import style0 from "./GlassBatchManualForm.vue?vue&type=style&index=0&id=415825bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415825bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VDataTable,VRow})
